module.exports = __webpack_public_path__ + "assets/fonts/roboto-condensed-v16-latin-regular.woff";